(function () {
  var mobile = window.matchMedia ? window.matchMedia('(max-width: 749px)') : null;
  var setup = function () {
    [].forEach.call(document.querySelectorAll('.nh-pdp__preflight-grid > article, .nh-cat__preflight-grid > article'), function (card) {
      if (card.hasAttribute('data-compact-acc')) return;
      card.setAttribute('data-compact-acc', '');
      var sync = function () {
        if (mobile && mobile.matches) {
          card.setAttribute('role', 'button');
          card.setAttribute('tabindex', '0');
          card.setAttribute('aria-expanded', card.classList.contains('is-open') ? 'true' : 'false');
        } else {
          card.removeAttribute('role');
          card.removeAttribute('tabindex');
          card.removeAttribute('aria-expanded');
        }
      };
      var toggle = function () {
        if (mobile && !mobile.matches) return;
        card.classList.toggle('is-open');
        sync();
      };
      card.addEventListener('click', toggle);
      card.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); toggle(); }
      });
      if (mobile && mobile.addEventListener) mobile.addEventListener('change', sync);
      sync();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup);
  else setup();
})();
